import React from 'react';
import {
  DescriptionOutlined as DescriptionOutlinedIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { CLIENT_STEP2_TEXT } from '../constants.ts';
import { guaranteesClientStep2Styles } from '../styles.ts';
import type { TClientDocumentRowProps } from '../types.ts';
import { buildClientDocumentMenuId } from '../utils.ts';
import ClientDocumentActionMenu from './ClientDocumentActionMenu.tsx';

const ClientDocumentRow: React.FC<TClientDocumentRowProps> = ({
  document,
  isLast,
  isUploading,
  isDownloading,
  isDeleting,
  isMenuOpen,
  isDisabled = false,
  actionMenuAnchorEl,
  onActionMenuOpen,
  onActionMenuClose,
  onDownload,
  onDeleteUploadedDocument,
}) => {
  const hasUploadedFile = !!(document.applicationFileId || document.fileId);
  const isBusy = isUploading || isDownloading || isDeleting;
  const chooseActionButtonContent =
    isDownloading || isDeleting
      ? <CircularProgress size={18} />
      : CLIENT_STEP2_TEXT.chooseActionButton;

  return (
    <Box sx={guaranteesClientStep2Styles.documentRow(isLast)}>
      <Box sx={guaranteesClientStep2Styles.documentNameWrap}>
        <DescriptionOutlinedIcon sx={guaranteesClientStep2Styles.documentIcon} />
        <Typography component="span" sx={guaranteesClientStep2Styles.documentFileName}>
          {document.fileName ?? CLIENT_STEP2_TEXT.emptyDocumentName}
        </Typography>
      </Box>

      <Box sx={guaranteesClientStep2Styles.documentActions}>
        {hasUploadedFile && (
          <>
            <Button
              variant="outlined"
              size="small"
              disabled={isBusy}
              onClick={onActionMenuOpen}
              sx={guaranteesClientStep2Styles.documentFileButton}
              endIcon={isMenuOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              aria-controls={isMenuOpen ? buildClientDocumentMenuId(document.id) : undefined}
              aria-haspopup="true"
              aria-expanded={isMenuOpen ? 'true' : undefined}
            >
              {chooseActionButtonContent}
            </Button>

            <ClientDocumentActionMenu
              anchorEl={actionMenuAnchorEl}
              document={document}
              isOpen={isMenuOpen}
              isDeleteDisabled={isDisabled || isBusy}
              onClose={onActionMenuClose}
              onDownload={onDownload}
              onDeleteUploadedDocument={onDeleteUploadedDocument}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

export default ClientDocumentRow;
